import moment from "moment";
import ko from "knockout";
import $ from "jquery";
import { Artist } from "./Artist";
import { BillingDetails } from "./Billing";
import { Host } from "./Host";

export class BasePerson {
  constructor(data) {
    var self = this;

    self.type = "BasePerson";

    self.rootvm = data.rootvm;
    self.person_uuid = ko.observable(data.person_uuid);
    self.email_address = ko.observable(data.email_address);
    self.display_name = ko.observable(data.display_name);
    self.phone = ko.observable(data.phone);
    self.person_status = ko.observable(data.person_status);
    self.group_title = ko.observable(data.group_title);
    self.original_group_title = ko.observable(data.group_title);
    self.raw_password = ko.observable(data.raw_password);
    self.mangopayid = ko.observable(data.mangopayid);
    self.language = ko.observable(data.language);
    self.referrer = ko.observable(data.referrer);
    self.landing_page = ko.observable(data.landing_page);
    self.last_activity = ko.observable(new moment(data.last_activity));
    self.last_activity().isValid()
      ? self.last_activity(self.last_activity().format("DD.MM.YY HH:mm:ss"))
      : self.last_activity("Never");
    self.allow_transfer = ko.observable(data.allow_transfer || false);
    self.payment_terms = ko.observable(data.payment_terms);
    self.billing_super_user = ko.observable(data.billing_super_user || false);
    self.can_always_add_attachments = ko.observable(
      data.can_always_add_attachments || false
    );
    self.sendnews = ko.observable(data.sendnews || false);
    self.sendartistnews = ko.observable(data.sendartistnews || false);
    self.special_discount = ko.observable(data.special_discount || false);
    self.preferred_currency = ko.observable(data.preferred_currency);

    self.referral_report = ko.observable();

    self.is_superuser = ko.observable(data.is_superuser);

    self.extra_notes = ko.observable(data.admin_comment);
    self.new_extra_notes = ko.observable(data.admin_comment);
    self.editing_extra_notes = ko.observable(false);

    self.email_sent_log = ko.observableArray(data.email_sent_log ?? []);

    self.admin_package_sent = ko.observable();
    if (data.admin_package_sent) {
      self.admin_package_sent(
        new moment(data.admin_package_sent || null).format("DD.MM.YY")
      );
    }

    self.inserted = ko.observable(new moment(data.inserted));

    self.new_person_status = ko.observable(data.person_status);
    self.new_allow_transfer = ko.observable(data.allow_transfer || false);
    self.new_payment_terms = ko.observable(data.payment_terms);
    self.new_billing_super_user = ko.observable(
      data.billing_super_user || false
    );
    self.new_can_always_add_attachments = ko.observable(
      data.can_always_add_attachments || false
    );
    self.new_sendnews = ko.observable(data.sendnews || false);
    self.new_sendartistnews = ko.observable(data.sendartistnews || false);

    self.artist = ko.observable(new Artist({}));
    self.host = ko.observable(new Host({}));
    self.billing_details = ko.observable(new BillingDetails({}));

    if (data.artist) {
      self.artist(new Artist(data.artist));
    }

    if (data.host) {
      self.host(new Host(data.host));
    }

    if (data.billing_details) {
      self.billing_details(new BillingDetails(data.billing_details));
    }

    self.system_emails_sent = ko.observableArray(data.system_emails_sent || []);

    self.login_link = ko.observable();
    self.login_link_artist = ko.observable();
    self.login_link_host = ko.observable();

    // If there's a payload
    self.payload = ko.observable(data.payload);

    self.toJSON = function () {
      return {
        person_uuid: self.person_uuid(),
        email_address: self.email_address(),
        display_name: self.display_name(),
        password: self.raw_password(),
      };
    };

    self.navigate_here_after_login_success = ko.observable();

    self.show_login_error = ko.observable(false);
    self.show_fb_login_error = ko.observable(false);

    self.message = ko.observable();

    self.lookup_host = function () {
      return $.ajax({
        url: self.rootvm.web_host + "/api/user/host",
        type: "GET",
        contentType: "application/json; charset=utf-8",

        success: function (result) {
          if (result.success) {
            var h = result.host;
            h.rootvm = self.rootvm;
            self.host(new Host(h));
          }
        },

        error: function (data) {
          console.log(data.message);
        },
      });
    };

    self.lookup_artist = function () {
      return $.ajax({
        url: self.rootvm.web_artist + "/api/user/artist",
        type: "GET",
        contentType: "application/json; charset=utf-8",

        success: function (result) {
          if (result.success) {
            var h = result.artist;
            h.rootvm = self.rootvm;
            self.artist(new artist(h));
          }
        },

        error: function (data) {
          console.log(data.message);
        },
      });
    };

    self.update_self = function (data) {
      if (data.session && data.session.user) {
        var d = data.session.user;
        self.person_uuid(d.person_uuid);
        self.email_address(d.email_address);
        self.display_name(d.display_name);
        self.group_title(d.group_title);
        self.is_superuser(d.is_superuser);
      } else {
        self.person_uuid(null);
        self.email_address(null);
        self.display_name(null);
        self.group_title(null);
        self.is_superuser(null);
      }
    };

    self.update_person_details = function (d) {
      if (d) {
        self.person_uuid(d.person_uuid);
        self.email_address(d.email_address);
        self.display_name(d.display_name);
        self.language(d.language);
        self.phone(d.phone);
      }
    };

    self.forgot_password = ko.observable(false);

    self.forgot_password_label = ko.computed(function () {
      if (self.forgot_password()) {
        return "Go back to login screen";
      } else {
        return "click here if you forgot your password";
      }
    });

    self.toggle_forgot_password = function () {
      self.forgot_password(!self.forgot_password());
    };

    self.reset_email_sent = ko.observable(false);

    self.change_status = function (new_status) {
      self.rootvm.syslog("Changing status of account");
      self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/change-status",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          new_status: new_status,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          self.rootvm.syslog("Changed status");
          self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.person_status(data.person_status);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.cancel_extra_notes = function () {
      self.new_extra_notes(self.extra_notes());
      self.editing_extra_notes(false);
    };

    self.save_extra_notes = function () {
      return $.ajax({
        url: scvm.web_host + "/api/admin/people/admin-comment",
        type: "POST",
        data: ko.toJSON({
          person_uuid: self.person_uuid(),
          admin_comment: self.new_extra_notes(),
        }),
        processData: false,

        contentType: "application/json; charset=utf-8",

        success: function (data) {
          if (data.success) {
            self.extra_notes(data.admin_comment);
            self.editing_extra_notes(false);
            notyf.success("Saved!");
          } else {
            notyf.error(data.message);
          }
        },
        error: function (jqXHR, errorStatus, thrownError) {
          var response = jQuery.parseJSON(jqXHR.responseText);
          notyf.error(response.message);
        },
        complete: function () {},
      });
    };

    self.set_sendnews = function (sendnews) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/sendnews",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          sendnews: sendnews,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.sendnews(sendnews);
            self.new_sendnews(sendnews);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_sendartistnews = function (sendartistnews) {
      return $.ajax({
        url: "/api/admin/sendartistnews",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          sendartistnews: sendartistnews,
          person_uuid: self.person_uuid(),
        }),
        success: function (data) {
          if (data.success) {
            self.sendartistnews(sendartistnews);
            self.new_sendartistnews(sendartistnews);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_payment_terms = function (payment_terms) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/payment-terms",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          payment_terms: payment_terms,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.payment_terms(payment_terms);
            self.new_payment_terms(payment_terms);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_allow_transfer = function (allow_transfer) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/allow-transfer",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          allow_transfer: allow_transfer,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.allow_transfer(allow_transfer);
            self.new_allow_transfer(allow_transfer);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.set_can_always_add_attachments = function (
      can_always_add_attachments
    ) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/can-always-add-attachments",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          can_always_add_attachments: can_always_add_attachments,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.can_always_add_attachments(can_always_add_attachments);
            self.new_can_always_add_attachments(can_always_add_attachments);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };
    self.set_billing_super_user = function (billing_super_user) {
      //self.rootvm.is_busy(true);
      return $.ajax({
        url: "/api/admin/can-set-commission",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          billing_super_user: billing_super_user,
          person_uuid: self.person_uuid(),
        }),

        complete: function (data) {
          //self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            self.billing_super_user(billing_super_user);
            self.new_billing_super_user(billing_super_user);
            notyf.success(data.message);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.change_person_group = function () {
      self.rootvm.syslog("Changing status");
      self.rootvm.is_busy(true);

      return $.ajax({
        url: "/api/change-person-group",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          person_uuid: self.person_uuid(),
          new_group: self.group_title(),
        }),

        complete: function () {
          self.rootvm.syslog("Updated group");
          self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            notyf.success(data.message);
            self.original_group_title(self.group_title());
          } else if (data.success == false && data.needs_to_log_in) {
            notyf.error(data.message);
            pager.navigate("login");
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.send_reset_password_email = function () {
      self.rootvm.syslog("Sending email with password-reset link");
      self.rootvm.is_busy(true);

      return $.ajax({
        url: "/api/send-reset-password-email",
        type: "POST",
        contentType: "application/json; charset=utf-8",
        processData: false,

        data: ko.toJSON({
          email_address: self.email_address(),
        }),

        complete: function () {
          self.rootvm.syslog("Sent password-reset email");
          self.rootvm.is_busy(false);
        },

        success: function (data) {
          if (data.success) {
            notyf.success(data.message);
            self.reset_email_sent(true);
          } else {
            notyf.error(data.message);
          }
        },
      });
    };

    self.new_password1 = ko.observable();
    self.new_password2 = ko.observable();
    self.current_password = ko.observable();

    self.new_passwords_match = ko.computed(function () {
      var p1 = self.new_password1();
      var p2 = self.new_password2();

      if (!p1) {
        return false;
      } else {
        return p1 == p2;
      }
    });

    self.password_entropy = ko.computed(function () {
      // I'm doing this to make knockout understand that I depend on
      // new_password1.
      var p = self.new_password1();

      if (p === undefined || p === null) {
        return "";
      } else {
        return p.length;
      }
    });

    self.password_css = ko.computed(function () {
      var e = self.password_entropy();

      if (e == "") {
        return "";
      } else if (e < 5) {
        return "strong text-danger";
      } else if (e < 8) {
        return "text-info";
      } else {
        return "strong text-success";
      }
    });

    self.password_quality_label = ko.computed(function () {
      var e = self.password_entropy();

      if (e == "") {
        return "";
      } else if (e < 5) {
        return "bad password";
      } else if (e < 8) {
        return "OK password";
      } else {
        return "good password";
      }
    });

    self.reset_password = function () {
      if (!self.new_password1() || !self.new_password2()) {
        alert("Please fill out both boxes!");
      } else if (!self.new_passwords_match()) {
        alert("Looks like those passwords don't match!");
      } else {
        self.rootvm.syslog("Resetting password");
        self.rootvm.is_busy(true);

        return $.ajax({
          url: "/api/reset-password",
          type: "POST",
          contentType: "application/json; charset=utf-8",
          processData: false,

          data: ko.toJSON({
            payload: self.rootvm.payload(),
            password: self.new_password1(),
          }),

          complete: function () {
            self.rootvm.syslog("Reset password");
            self.rootvm.is_busy(false);
          },

          success: function (data) {
            if (data.success) {
              notyf.success(data.message);
              pager.navigate("login");
            } else {
              notyf.error(data.message);
            }
          },
        });
      }
    };

    self.update_password = function () {
      if (!self.new_passwords_match()) {
        notyf.error("Sorry, passwords don't match!");
        return;
      } else {
        self.rootvm.is_busy(true);
        self.rootvm.syslog("Updating password");

        return $.ajax({
          url: "/api/update-password",
          method: "POST",

          data: ko.toJSON({
            current_password: self.current_password(),
            new_password1: self.new_password1(),
            new_password2: self.new_password2(),
          }),

          contentType: "application/json; charset=utf-8",
          processData: false,

          complete: function () {
            self.rootvm.is_busy(false);
            self.rootvm.syslog("Updated password");
          },

          success: function (data) {
            if (data.success) {
              self.current_password(null);
              self.new_password1(null);
              self.new_password2(null);
              notyf.success(data.message);
            } else {
              notyf.error(data.message);
            }
          },
        });
      }
    };

    self.complete_invite_register = function () {
      if (!self.new_password1() || !self.new_password2()) {
        alert("Please fill out both boxes!");
      } else if (!self.new_passwords_match()) {
        alert("Looks like those passwords don't match!");
      } else {
        self.rootvm.syslog("Completing user invite registration");
        self.rootvm.is_busy(true);

        return $.ajax({
          url: "/api/invite-register-completion",
          type: "POST",
          contentType: "application/json; charset=utf-8",
          processData: false,

          data: ko.toJSON({
            payload: self.payload(),
            password: self.new_password1(),
            display_name: self.display_name(),
          }),

          complete: function () {
            self.rootvm.syslog("Reset password");
            self.rootvm.is_busy(false);
          },

          success: function (data) {
            if (data.success) {
              notyf.success(data.message);
              pager.navigate("login");
            } else {
              notyf.error(data.message);
            }
          },
        });
      }
    };

    self.initialize = function () {
      self.rootvm.check_login_status().then(function () {
        if (!self.rootvm.user_logged_in()) {
          pager.navigate("login");
        }
      });
    };

    self.show_mismatched_password_warning = ko.computed(function () {
      if (
        self.new_password1() &&
        self.new_password2() &&
        !self.new_passwords_match()
      ) {
        return true;
      } else {
        return false;
      }
    });

    self.update_password_button_text = ko.computed(function () {
      if (self.rootvm && self.rootvm.is_busy()) {
        return "Updating...";
      } else {
        return "Update password";
      }
    });

    self.add_new_user_disable = ko.computed(function () {
      if (self.display_name() && self.raw_password() && self.email_address()) {
        return false;
      } else {
        return true;
      }
    });

    self.invite_register_complete_disable = ko.computed(function () {
      if (self.display_name() && self.new_passwords_match()) {
        return false;
      } else {
        return true;
      }
    });

    // TODO: still needed?
    self.reset_new_user_form = function () {
      self.display_name(null);
      self.email_address(null);
      self.raw_password(null);
      self.group_title(null);
    };
  }
}
